import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import LazyImage from '../../components/ui/LazyImage/LazyImage';
import './Deals.css'; // Assurez-vous que les styles nécessaires sont dans Deals.css ou importés globalement

export const SortableDealCard = ({ item, viewMode, onEdit, onDelete, isDeleting, itemToDelete }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: item.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  // Note: Les classes CSS comme 'deal-card' et 'deal-image' etc. doivent correspondre à votre Deals.css
  // ou être adaptées.
  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className={`deal-card ${viewMode} ${isDragging ? 'dragging' : ''}`}
    >
      {/* Badge pour l'ordre */}
      {typeof item.order !== 'undefined' && (
        <div className="order-badge"> {/* Cette classe doit être définie dans Deals.css ou globalement */}
          {item.order}
        </div>
      )}
      <div className="deal-image">
        <LazyImage 
          src={item.imageUrl} 
          alt={item.titre} 
        />
      </div>
      <div className="deal-content">
        <h3>{item.titre}</h3>
        <p>{item.description}</p>
        {/* Si les deals ont une catégorie ou un champ similaire, ajoutez-le ici */}
      </div>
      <div className="deal-actions">
        <button 
          className="edit-btn"
          onClick={(event) => {
            event.stopPropagation(); // Empêche l'événement de se propager à la carte
            onEdit(item);
          }}
        >
          Modifier
        </button>
        <button 
          className="delete-btn"
          onClick={(event) => {
            event.stopPropagation(); // Empêche l'événement de se propager à la carte
            onDelete(item);
          }}
          disabled={isDeleting}
        >
          {isDeleting && itemToDelete?.id === item.id ? 'Suppression...' : 'Supprimer'}
        </button>
      </div>
    </div>
  );
}; 